import styled from 'styled-components';

import { getThemeColor } from '@utils/styled';

import Typography from '@common/components/Typography';

export const PersonalizationModalWrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'scale', 3)}
  ${({ theme }) => theme.getFluidSpacing('padding-top', 'scale', 3)}
  margin: 0 2.5rem;
`;

export const PersonalizationModalForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 565px;
  max-height: 100%;
  border-radius: ${({ theme }) => theme.borderRadiuses['normal.1']}rem;
  ${({ theme }) => theme.getFluidSpacing('padding-top', 'scale', 5)}
  ${({ theme }) => theme.getFluidSpacing('padding-right', 'scale', 7)}
  ${({ theme }) => theme.getFluidSpacing('padding-left', 'scale', 7)}
  background-color: #fff;
`;

export const PersonalizationModalInner = styled.div`
  overflow: auto;
  ${({ theme }) => theme.getFluidSpacing('padding-right', 'scale', 7)}
  ${({ theme }) => theme.getFluidSpacing('padding-left', 'scale', 7)}
`;

export const PersonalizationInputRow = styled.div`
  margin-bottom: 2.5rem;
`;

export const PersonalizationInputHint = styled(Typography).attrs({
  variant: 'body4',
})`
  margin: 1rem 0 0;
  color: ${getThemeColor('bluegrey.60')};
`;

export const PersonalizationActionRow = styled.div`
  border-top: 1px solid ${getThemeColor('bluegrey.80')};
  ${({ theme }) => theme.getFluidSpacing('margin-right', 'scale', 7, true)}
  ${({ theme }) => theme.getFluidSpacing('margin-left', 'scale', 7, true)}
  padding: 1.5rem;
  text-align: center;
`;
